export const initialState = {
  columns: {
    columns: [],
    tasksOrder: [],
  },
  tasks: [],
};
